import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import PreviewBox from "../components/PreviewBox";

function CustomAvatarPage() {
  const [searchParams] = useSearchParams();
  const [imagePreview, setImagePreview] = useState(null);
  const [agent, setAgent] = useState(null);
  const [progressText, setProgressText] = useState("");
  const [roomUrl, setRoomUrl] = useState(null);

  const faceId = searchParams.get("face-id");
  const voiceId = searchParams.get("voice-id");
  const simliApiKey = "n8sesdejo1tnudor5ljcg";

  useEffect(() => {
    if (faceId) {
      // Fetch face preview if face ID is provided
      fetch(`https://api.simli.ai/getRequestStatus?face_id=${faceId}`, {
        method: "POST",
        headers: { "api-key": simliApiKey },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.image_url) {
            setImagePreview(data.image_url);
          }
        })
        .catch((err) => console.error("❌ Face preview error:", err));
    }
  }, [faceId]);

  const startSession = async () => {
    if (!faceId || !voiceId) {
      alert("Please provide both face-id and voice-id in the URL");
      return;
    }

    const payload = {
      apiKey: simliApiKey,
      faceId,
      voiceId,
      ttsProvider: "Cartesia",
      ttsModel: "sonic-turbo-2025-03-07",
      ttsAPIKey: "sk_car_ANhQon9hRbqMDBgR5Z5n9Q",
      systemPrompt: "You are a helpful assistant.",
      firstMessage: "Hello! Let's chat.",
      language: "en",
      maxSessionLength: 3600,
      maxIdleTime: 300,
    };

    try {
      const res = await fetch("https://api.simli.ai/startE2ESession", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const result = await res.json();
      if (result?.roomUrl) setRoomUrl(result.roomUrl);
    } catch (error) {
      console.error("❌ Session could not be started:", error);
    }
  };

  return (
    <div className="flex w-full h-screen bg-white overflow-hidden">
      {/* Center: Chat or iframe */}
      <div className="w-full bg-[#dce3ea] flex items-center justify-center">
        {roomUrl ? (
          <iframe
            src={roomUrl}
            title="Simli Chat Session"
            className="w-[90%] h-[90%] rounded shadow"
            allow="camera; microphone; fullscreen"
          />
        ) : (
          <div className="text-center">
            <PreviewBox
              imagePreview={imagePreview}
              progressText={progressText}
            />
            <button
              onClick={startSession}
              className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded mt-4"
            >
              🎙️ Start Chat
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default CustomAvatarPage;
